// Copyright (c) StrangeBee 2024

import { LicenseController } from 'thehive-sdk';

export interface LicenseEventList {
    onSet: (license: string) => void;
}

interface LicenseEventListParams {
    locale: (label: string) => string;
    controller: LicenseController;
    onSuccess?: (count?: boolean, message?: string) => void;
    onError?: (label?: string) => void;
}

export const computeEventList = ({
    controller,
    locale,
    onError,
    onSuccess,
}: LicenseEventListParams): LicenseEventList => ({
    onSet: (license: string) => {
        controller
            .setLicense(license)
            .then(() => onSuccess?.(false, locale('notification.license.set')))
            .catch(onError);
    },
});
